/**
 * Constantes et helpers pour les profils alimentaires multiples.
 * L'identification visuelle se fait via l'initiale du prénom (cf. ProfileEditModal /
 * ProfilesWidget) — pas d'emoji.
 */

export function getDefaultProfileName(index) {
  if (index === 0) return 'Moi';
  return `Profil ${index + 1}`;
}

/**
 * Pose le marqueur blockPreferences.propagationFree sur un profil créé par le
 * client actuel : ce client ne recopie plus un vote de plat sur ses ingrédients,
 * donc ses refus d'ingrédients sont délibérés et ne doivent jamais être pris pour
 * une ancienne propagation (trigger onProfileCreatedTastes, migration). Un
 * `propagationFree: false` explicite (invité de l'ancien onboarding non nettoyé
 * côté client) est respecté : le serveur fera le nettoyage.
 */
export function withPropagationMarker(payload) {
  const p = payload || {};
  const bp = p.blockPreferences && typeof p.blockPreferences === 'object' ? p.blockPreferences : {};
  return { ...p, blockPreferences: { ...bp, propagationFree: bp.propagationFree !== false } };
}

/**
 * Retourne un objet profil "vide" prêt à être enregistré.
 * Utilisé par la migration legacy et la création manuelle.
 */
export function buildEmptyProfile(overrides = {}) {
  return {
    name: 'Moi',
    regime: 'Omnivore',
    allergies: {},
    aversions: '',
    ageGroup: 'adult',
    isDefault: false,
    ...overrides
  };
}
